import { LayersControl, TileLayer } from "react-leaflet";
import ReactLeafletGoogleLayerModule from "react-leaflet-google-layer";

// Vite 8 gives "type": "module" importers the raw module.exports of a CJS
// package flagged __esModule, so the component sits under .default.
const ReactLeafletGoogleLayer =
  (
    ReactLeafletGoogleLayerModule as unknown as {
      default?: typeof ReactLeafletGoogleLayerModule;
    }
  ).default ?? ReactLeafletGoogleLayerModule;

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
const MAPBOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;

interface MapTileLayersProps {
  position?: "topleft" | "topright" | "bottomleft" | "bottomright";
  showMapbox?: boolean;
  defaultLayer?: "osm" | "mapbox" | "satellite";
  osmLabel?: string;
}

const MapTileLayers: React.FC<MapTileLayersProps> = ({
  position,
  showMapbox = true,
  defaultLayer = "osm",
  osmLabel = "Principal",
}) => {
  return (
    <LayersControl {...(position ? { position } : {})}>
      <LayersControl.BaseLayer checked={defaultLayer === "osm"} name={osmLabel}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          maxZoom={22}
        />
      </LayersControl.BaseLayer>

      {showMapbox && (
        <LayersControl.BaseLayer
          checked={defaultLayer === "mapbox"}
          name="Simplificado"
        >
          <TileLayer
            attribution='&copy; <a href="https://www.mapbox.com">Mapbox</a> '
            url={`https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=${MAPBOX_ACCESS_TOKEN}`}
            maxZoom={22}
          />
        </LayersControl.BaseLayer>
      )}

      <LayersControl.BaseLayer
        checked={defaultLayer === "satellite"}
        name="Satélite"
      >
        <ReactLeafletGoogleLayer apiKey={GOOGLE_MAPS_API_KEY} type="hybrid" />
      </LayersControl.BaseLayer>
    </LayersControl>
  );
};

export default MapTileLayers;
